export default __webpack_public_path__ + "static/Second-38da53ea7db6dd16311a1aca5b87d158.svg";